import React from "react";

const NPRWidgetWarningIcon: React.FC<{ message?: string }> = ({ message }) => (
  <span className="inline-flex items-center ml-2" title={message || "Warning"}>
    <svg
      className="w-4 h-4 text-[var(--color-warning)]"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 9v2m0 4h.01M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9 9 4.03 9 9z"
      />
    </svg>
  </span>
);

export default NPRWidgetWarningIcon;
